import { CalendarCheck, Clock, UserCircle } from "@phosphor-icons/react";
import { SLIDE_RIGHT, motion, stagger, APT_TYPE_COLORS, APT_TYPE_LABELS } from "./constants";

export default function TodayAppointmentsCard({ appointments, onGoToCalendar }) {
  return (
    <div className="stat-card">
      <div className="flex items-center justify-between mb-4">
        <h3
          className="text-lg font-bold tracking-tight uppercase text-white"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          APPUNTAMENTI DI OGGI
        </h3>
        <button
          onClick={onGoToCalendar}
          className="text-[#007AFF] text-sm hover:text-[#3395FF] transition-colors font-medium"
          data-testid="view-calendar"
        >
          Calendario
        </button>
      </div>

      {appointments?.length > 0 ? (
        <div className="space-y-2">
          {appointments.map((apt, i) => {
            const color = APT_TYPE_COLORS[apt.appointment_type] || "#007AFF";
            return (
              <motion.div
                key={apt.id}
                {...SLIDE_RIGHT}
                transition={stagger(0.2, 0.08, i)}
                className="flex items-start gap-3 p-3 rounded-lg bg-[#0A0A0A] border border-[#1A1A1A]"
                data-testid={`today-appointment-${i}`}
              >
                <div
                  className="w-1 self-stretch rounded-full flex-shrink-0 mt-0.5"
                  style={{ backgroundColor: color }}
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span
                      className="px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider"
                      style={{ backgroundColor: `${color}20`, color }}
                    >
                      {APT_TYPE_LABELS[apt.appointment_type] || apt.appointment_type}
                    </span>
                    {apt.time_start && (
                      <span className="flex items-center gap-1 text-[11px] text-zinc-500">
                        <Clock size={11} />
                        {apt.time_start}{apt.time_end ? ` - ${apt.time_end}` : ""}
                      </span>
                    )}
                  </div>
                  <p className="text-sm font-medium text-white">{apt.title}</p>
                  {apt.client_name && (
                    <p className="flex items-center gap-1 text-xs text-zinc-500 mt-0.5">
                      <UserCircle size={13} />
                      {apt.client_name}
                    </p>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-10">
          <CalendarCheck size={36} weight="duotone" className="text-zinc-600 mx-auto mb-2" />
          <p className="text-zinc-500 text-sm">Nessun appuntamento oggi</p>
          <button
            onClick={onGoToCalendar}
            className="mt-2 text-[#007AFF] text-sm hover:text-[#3395FF] transition-colors"
            data-testid="add-appointment-dashboard"
          >
            Vai al calendario
          </button>
        </div>
      )}
    </div>
  );
}
